import shareEmail from 'assets/img/share_email.svg';
import shareWhatsApp from 'assets/img/share_whatsapp.svg';
import shareTwitter from 'assets/img/share_twitter.svg';
import shareFacebookIcon from 'assets/img/share_facebook.svg';

import {
  addProduct,
  deleteProduct,
  fetchGiftTableProducts,
} from 'store/actions/giftTable';

export const VARIANTS = {
  DEFAULT: '',
  MINIMALIST: 'minimalist',
  EXTRA_SMALL: 'extraSmall',
  PRIMARY: 'primary',
  NONE: 'none',
};

export const mapStateToProps = ({ giftTable, gifts }) => ({
  products: gifts.listOfGifts.results.list,
  listOfGifts: gifts.listOfGifts,
  tableInfo: giftTable.giftTableInfo.data,
  giftTableProducts: giftTable.giftTableProducts,
});

export const actions = {
  addProduct,
  deleteProduct,
  fetchGiftTableProducts,
};

let whatsappProtocol
if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator?.userAgent)){
  whatsappProtocol = 'https://wa.me/'
}else{
  whatsappProtocol = 'whatsapp://send'
}

export const SHARE_LINKS = [
  {
    id: 'email',
    alt: 'Compartir por correo electrónico',
    icon: shareEmail,
    getLink: (url) =>
      `mailto:tuinvitado@mail.com?subject=Mesa de regalos&body=Hola!%20Te comparto mi mesa de regalos: ${url}`,
  },
  {
    id: 'whatsapp',
    alt: 'Compartir en WhatsApp',
    icon: shareWhatsApp,
    getLink: (url) =>
      `${whatsappProtocol}?text=Hola%21%20Les%20dejo%20mi%20mesa%20de%20regalos%20%3A%29%20${url}`,
  },
  {
    id: 'twitter',
    alt: 'Compartir en Twitter',
    icon: shareTwitter,
    getLink: (url) =>
      `https://twitter.com/intent/tweet?text=Hola%21%20Les%20dejo%20mi%20mesa%20de%20regalos%20%3A%29&url=${url}`,
  },
  {
    id: 'facebook',
    alt: 'Compartir en Facebook',
    icon: shareFacebookIcon,
    getLink: (url) => `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=Hola%21%20Les%20dejo%20mi%20mesa%20de%20regalos%20%3A%29`,
  },
];
